"use client";

import React from "react";
import Link from "next/link";
import useFavorites from "@/hooks/useFavorites";
import ProductCard from "@/components/ProductCard";
import StaticBreadcrumbClient from "@/app/components/StaticBreadcrumbClient";

export default function FavoritesPage() {
    const { favorites, isHydrated } = useFavorites();
    const hasFavorites = favorites.length > 0;

    return (
        <div className="mx-auto mt-4 w-full max-w-[1536px] px-2 pb-12 md:mt-8 md:px-4">
            <div className="mb-4">
                <StaticBreadcrumbClient pageTitle="Избранное" />
            </div>
            <h1 className="text-2xl font-semibold md:text-3xl">Избранное</h1>

            {isHydrated ? (
                hasFavorites ? (
                    <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                        {favorites.map((item) => (
                            <ProductCard key={item.id} item={item} className="rounded-xl" />
                        ))}
                    </div>
                ) : (
                    <div className="mt-10 rounded-xl border border-dashed border-default-200 p-6 text-center text-sm text-default-500 md:p-10 md:text-base">
                        <p>Вы пока ничего не добавили в избранное.</p>
                        <Link
                            href="/shop"
                            className="mt-4 inline-flex items-center justify-center rounded-lg bg-primary px-5 py-2 text-sm font-semibold text-white transition hover:bg-primary/90"
                        >
                            Перейти в каталог
                        </Link>
                    </div>
                )
            ) : (
                <div className="mt-10 h-32 rounded-xl border border-dashed border-default-200 bg-default-50" aria-hidden="true" />
            )}
        </div>
    );
}
